var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHelp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#767673"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19797 9.396V9.084C7.19797 8.724 7.24197 8.42 7.32997 8.172C7.42597 7.916 7.54597 7.7 7.68997 7.524C7.83397 7.34 7.98597 7.184 8.14597 7.056C8.31397 6.92 8.46997 6.792 8.61397 6.672C8.75797 6.552 8.87397 6.424 8.96197 6.288C9.05797 6.144 9.10597 5.976 9.10597 5.784C9.10597 5.52 9.00997 5.324 8.81797 5.196C8.63397 5.068 8.37797 5.004 8.04997 5.004C7.63397 5.004 7.32197 5.112 7.11397 5.328C6.91397 5.536 6.81797 5.852 6.82597 6.276H5.22997C5.22997 5.684 5.34997 5.184 5.58997 4.776C5.82997 4.36 6.16597 4.044 6.59797 3.828C7.02997 3.612 7.52597 3.504 8.08597 3.504C8.54197 3.504 8.96597 3.58 9.35797 3.732C9.74997 3.884 10.066 4.132 10.306 4.476C10.554 4.812 10.678 5.26 10.678 5.82C10.678 6.172 10.63 6.468 10.534 6.708C10.438 6.948 10.314 7.152 10.162 7.32C10.018 7.488 9.86197 7.636 9.69397 7.764C9.53397 7.892 9.37797 8.024 9.22597 8.16C9.08197 8.288 8.96197 8.436 8.86597 8.604C8.76997 8.772 8.72197 8.976 8.72197 9.216V9.396H7.19797ZM7.05397 12V10.296H8.91397V12H7.05397Z",
    fill: "#5E5E5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp);
export default __webpack_public_path__ + "static/media/Icon-Help.d26cf9a1badc5e38f8319796273393f7.svg";
export { ForwardRef as ReactComponent };